export const FREE_SHIPPING_THRESHOLD = 396;
export const GREEN_DELIVERY_TRUCK_ICON = 'https://assets.homedepot-static.com/images/v1/truck-icon-green.svg';
